import React, { Component } from "react";
import PropTypes from "prop-types";
import SidebarLink from "./SidebarLink";
import SidebarCategory from "./SidebarCategory";
import * as roles from "../../../shared/service/roles";

class SidebarContent extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
  };

  state = {
    permissions: [],
  };

  hideSidebar = () => {
    this.props.onClick();
  };

  // <ul className="sidebar__block">
  //   <SidebarLink
  //     title="Dashboard"
  //     route="/dashboard_default"
  //     icon="chart-bars"
  //     onClick={this.hideSidebar}
  //   />
  //   <SidebarLink
  //     title="Proxy Status"
  //     route="/proxy_status"
  //     icon="checkmark-circle"
  //     onClick={this.hideSidebar}
  //   />
  //   <SidebarLink
  //     title="Panel Protector"
  //     icon="heart"
  //     route="/panel_protection"
  //     onClick={this.hideSidebar}
  //   />
  //   <SidebarLink
  //     title="Refresh Requests"
  //     icon="sync"
  //     route="/refresh_requests"
  //     onClick={this.hideSidebar}
  //   />
  //   <SidebarLink
  //     title="User Activity"
  //     icon="warning"
  //     route="/user_activity"
  //     onClick={this.hideSidebar}
  //   />
  //   <SidebarLink
  //     title="URL check"
  //     route="/url_check"
  //     icon="redo"
  //     onClick={this.hideSidebar}
  //   />
  //   <SidebarLink
  //     title="View"
  //     route="/view"
  //     icon="magnifier"
  //     onClick={this.hideSidebar}
  //   />
  //   <SidebarLink
  //     title="Credit Pending"
  //     route="/credit_pending"
  //     icon="flag"
  //     onClick={this.hideSidebar}
  //   />
  //   <SidebarLink
  //     title="Sample Proxy List"
  //     route="/proxy_list"
  //     icon="list"
  //     onClick={this.hideSidebar}
  //   />
  // </ul>

  componentDidMount = () => {
    roles.getProfile().then((res) => this.setState(res));
  };

  render() {
    return (
      <div className="sidebar__content">
        <ul className="sidebar__block">
          <SidebarLink
            title="Dashboard"
            route="/dashboard"
            icon="chart-bars"
            onClick={this.hideSidebar}
          />
          {this.state.permissions.team !== undefined &&
          this.state.permissions.team.GET !== undefined &&
          this.state.permissions.team.GET === 1 ? (
            <React.Fragment>
              <SidebarCategory title="Team" icon="users">
                <SidebarLink
                  title="Team"
                  route="/team"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Roles"
                  route="/roles"
                  onClick={this.hideSidebar}
                />
              </SidebarCategory>
            </React.Fragment>
          ) : (
            <React.Fragment></React.Fragment>
          )}

          {this.state.permissions.users !== undefined &&
          this.state.permissions.users.GET !== undefined &&
          this.state.permissions.users.GET === 1 ? (
            <React.Fragment>
              <SidebarCategory title="Users" icon="users">
                <SidebarLink
                  title="All Users"
                  route="/users/all"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Active Users"
                  route="/users/active"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Paid Users"
                  route="/users/paid"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Recent Sign-ups"
                  route="/users/recent"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Cancelled Users"
                  route="/users/cancelled"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Cancellation Requests"
                  route="/users/cancellation_requests"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Trial Expired"
                  route="/users/trial_expired"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Pending"
                  route="/users/pending"
                  onClick={this.hideSidebar}
                />
              </SidebarCategory>
            </React.Fragment>
          ) : (
            <React.Fragment></React.Fragment>
          )}

          {/* <SidebarLink title="Roles and Permissions" icon="lock" route="/roles" onClick={this.hideSidebar} /> */}
          {/* <SidebarLink
            title="Products"
            route="/products"
            onClick={this.hideSidebar}
          />
          <SidebarLink
            title="Transactions"
            route="/transactions/all"
            onClick={this.hideSidebar}
            icon="printer"
          />

          <SidebarLink
            title="List orders"
            route="/list_orders"
            onClick={this.hideSidebar}
          />
          <SidebarLink
            title="Manage orders"
            route="/manage_orders"
            onClick={this.hideSidebar}
          /> 
          <SidebarCategory title="Logs" icon="sync">
            <SidebarLink
              title="User Activity"
              route="/user/logs"
              onClick={this.hideSidebar}
            />
            <SidebarLink
              title="Gateway Logs"
              route="/gateway/logs"
              onClick={this.hideSidebar}
            />
          </SidebarCategory>
          */}
          {this.state.permissions.packages !== undefined &&
          this.state.permissions.packages.GET !== undefined &&
          this.state.permissions.packages.GET === 1 ? (
            <React.Fragment>
              <SidebarLink
                title="Products"
                route="/packages"
                onClick={this.hideSidebar}
                icon="list"
              />
            </React.Fragment>
          ) : (
            <React.Fragment></React.Fragment>
          )}

          <SidebarLink
            title="Credits Pending"
            route="/credits/pending"
            onClick={this.hideSidebar}
            icon="store"
          />

          {this.state.permissions.subscriptions !== undefined &&
          this.state.permissions.subscriptions.GET !== undefined &&
          this.state.permissions.subscriptions.GET === 1 ? (
            <React.Fragment>
              <SidebarCategory title="Subscriptions" icon="redo">
                <SidebarLink
                  title="All Subscriptions"
                  route="/subscriptions/all"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Active Subscriptions"
                  route="/subscriptions/active"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Inactive Subscriptions"
                  route="/subscriptions/inactive"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Cancellation Requests"
                  route="/subscriptions/terminate_pending"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Refresh Requests"
                  route="/subscriptions/refresh_pending"
                  onClick={this.hideSidebar}
                />
              </SidebarCategory>
            </React.Fragment>
          ) : (
            <React.Fragment></React.Fragment>
          )}

          <SidebarCategory title="Proxy" icon="database">
            {this.state.permissions.nodes !== undefined &&
            this.state.permissions.nodes.GET !== undefined &&
            this.state.permissions.nodes.GET === 1 ? (
              <React.Fragment>
                <SidebarLink
                  title="Nodes"
                  route="/proxy/nodes"
                  onClick={this.hideSidebar}
                />
              </React.Fragment>
            ) : (
              <React.Fragment></React.Fragment>
            )}

            {this.state.permissions.subnets !== undefined &&
            this.state.permissions.subnets.GET !== undefined &&
            this.state.permissions.subnets.GET === 1 ? (
              <React.Fragment>
                <SidebarLink
                  title="Subnets"
                  route="/proxy/subnets"
                  onClick={this.hideSidebar}
                />
              </React.Fragment>
            ) : (
              <React.Fragment></React.Fragment>
            )}

            {this.state.permissions.tags !== undefined &&
            this.state.permissions.tags.GET !== undefined &&
            this.state.permissions.tags.GET === 1 ? (
              <React.Fragment>
                <SidebarLink
                  title="Tags"
                  route="/proxy/tags"
                  onClick={this.hideSidebar}
                />
              </React.Fragment>
            ) : (
              <React.Fragment></React.Fragment>
            )}

            {this.state.permissions.locations !== undefined &&
            this.state.permissions.locations.GET !== undefined &&
            this.state.permissions.locations.GET === 1 ? (
              <React.Fragment>
                <SidebarLink
                  title="Locations"
                  route="/proxy/locations"
                  onClick={this.hideSidebar}
                />
              </React.Fragment>
            ) : (
              <React.Fragment></React.Fragment>
            )}

            {this.state.permissions.usecases !== undefined &&
            this.state.permissions.usecases.GET !== undefined &&
            this.state.permissions.usecases.GET === 1 ? (
              <React.Fragment>
                <SidebarLink
                  title="Use Case"
                  route="/proxy/use-cases"
                  onClick={this.hideSidebar}
                />
              </React.Fragment>
            ) : (
              <React.Fragment></React.Fragment>
            )}

            {this.state.permissions.usecases !== undefined &&
            this.state.permissions.usecases.GET !== undefined &&
            this.state.permissions.usecases.GET === 1 ? (
              <React.Fragment>
                <SidebarLink
                  title="Residential"
                  route="/proxy/residential-proxies"
                  onClick={this.hideSidebar}
                />
              </React.Fragment>
            ) : (
              <React.Fragment></React.Fragment>
            )}

            {this.state.permissions.websites !== undefined &&
            this.state.permissions.websites.GET !== undefined &&
            this.state.permissions.websites.GET === 1 ? (
              <React.Fragment>
                <SidebarLink
                  title="Websites"
                  route="/proxy/websites"
                  onClick={this.hideSidebar}
                />
              </React.Fragment>
            ) : (
              <React.Fragment></React.Fragment>
            )}
          </SidebarCategory>

          {this.state.permissions.users !== undefined &&
          this.state.permissions.users.GET !== undefined &&
          this.state.permissions.users.GET === 1 ? (
            <React.Fragment>
              <SidebarLink
                title="Audit Logs"
                route="/logs/audit"
                icon="history"
                onClick={this.hideSidebar}
              />
            </React.Fragment>
          ) : (
            <React.Fragment></React.Fragment>
          )}
          {/* <SidebarCategory title="Logs" icon="history">
            <SidebarLink
              title="Audit Logs"
              route="/logs/audit"
              onClick={this.hideSidebar}
            />
          </SidebarCategory> */}

          {this.state.permissions.restrictions !== undefined &&
          this.state.permissions.restrictions.GET !== undefined &&
          this.state.permissions.restrictions.GET === 1 ? (
            <React.Fragment>
              <SidebarCategory title="Settings" icon="cog">
                <SidebarLink
                  title="Blocklist"
                  route="/settings/blocklist"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="On Verify"
                  route="/settings/on-verify"
                  onClick={this.hideSidebar}
                />
              </SidebarCategory>
            </React.Fragment>
          ) : (
            <React.Fragment></React.Fragment>
          )}

          {/* <SidebarCategory title="Tools" icon="cog">
            <SidebarLink
              title="URL check"
              route="/url_check"
              onClick={this.hideSidebar}
            />
            <SidebarLink
              title="View"
              route="/view"
              onClick={this.hideSidebar}
            />
            <SidebarLink
              title="Panel Protector"
              route="/panel_protection"
              onClick={this.hideSidebar}
            />
            <SidebarLink
              title="Proxy Status"
              route="/proxy_status"
              onClick={this.hideSidebar}
            />
            <SidebarLink
              title="Sample Proxy List"
              route="/proxy_list"
              onClick={this.hideSidebar}
            />
          </SidebarCategory> */}
        </ul>
      </div>
    );
  }
}

export default SidebarContent;
